export default "__VITE_ASSET__oEt8k0ZG7EV$3JSkDP93sQ__"